import { SCAN_CONSTANTS } from '../constants/scanConstants';

export const fastDomainCheckRequest = (payload) => ({
  type: SCAN_CONSTANTS.FAST_DOMAIN_CHECK_REQUEST,
  payload,
});

export const fastDomainCheckSuccess = (payload) => ({
  type: SCAN_CONSTANTS.FAST_DOMAIN_CHECK_SUCCESS,
  payload,
});

export const fastDomainCheckFailure = (payload) => ({
  type: SCAN_CONSTANTS.FAST_DOMAIN_CHECK_FAILURE,
  payload,
});

export const getScansRequest = (payload) => ({
  type: SCAN_CONSTANTS.GET_SCANS_REQUEST,
  payload,
});

export const getScansSuccess = (payload) => ({
  type: SCAN_CONSTANTS.GET_SCANS_SUCCESS,
  payload,
});

export const getScansFailure = (payload) => ({
  type: SCAN_CONSTANTS.GET_SCANS_FAILURE,
  payload,
});

export const getOemScansRequest = (payload) => ({
  type: SCAN_CONSTANTS.GET_OEM_SCANS_REQUEST,
  payload,
});

export const getOemScansSuccess = (payload) => ({
  type: SCAN_CONSTANTS.GET_OEM_SCANS_SUCCESS,
  payload,
});

export const getOemScansFailure = (payload) => ({
  type: SCAN_CONSTANTS.GET_OEM_SCANS_FAILURE,
  payload,
});

export const resetScanState = () => ({
  type: SCAN_CONSTANTS.RESET_SCAN_STATE,
});